import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree} from '@angular/router';
import {MsalGuard} from "@azure/msal-angular";
import {Observable, of} from "rxjs";
import {inject, Injectable} from "@angular/core";
import {ImpersonationService} from "../services/impersonation.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard extends MsalGuard {
  private readonly impersonationService = inject(ImpersonationService);

  override canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (this.impersonationService.hasImpersonationToken()) {
      return of(true);
    }

    return super.canActivate(route, state);
  }
}
